import { Race, Location } from "../../api/model";
import * as React from "react";
import { TwoColumnsGridData, TwoColumnsGrid } from "../TwoColumnsGrid";
import { RaceTypeLabels, RaceStateLabels } from "../../EnumsLabels";

export interface RaceDataComponentProps {
  race: Race;
}

const fd = (date: number | null | undefined, def: string) => {
  if (!date) {
    return def;
  }
  return new Date(date).toLocaleString();
};

export default (props: RaceDataComponentProps) => {
  // return <div>{JSON.stringify(props, null, 2)}</div>
  const { race } = props;

  console.log("props de race", race);

  const getAddress = (destiny: Location) => {
    console.log(destiny);
    return `${destiny.street1.replace(", Paraguay", "")} ${
      destiny.number ? `#${destiny.number}` : ""
    }`;
  };
  const colunms: TwoColumnsGridData[] = [
    { type: "title", label: "Cliente" },
    { type: "divider" },
    { label: "Nombre", value: race.owner.user.name },
    { label: "Email", value: race.owner.user.email },
    { label: "Telefono", value: race.owner.phone },
    { label: "Cédula/RUC", value: race.owner.document },

    { type: "title", label: RaceTypeLabels[race.type] },
    { type: "divider" },
    { label: "Dirección de Entrega:", value: getAddress(race.route.destiny) },
    { label: "Estado", value: RaceStateLabels[race.state] },
    { label: "Observación", value: race.observation },
    // { label: 'Monto', value: race.capital ? race.capital.toLocaleString() : 'Sin monto' },
  ];

  // if (race.driver) {
  //     colunms.push(
  //         { type: 'title', label: 'Conductor' },
  //         { type: 'divider' },
  //         { label: 'Nombre', value: race.driver.user.name }
  //     );
  // }

  colunms.push(
    { type: "title", label: "Fechas (control)" },
    { type: "divider" },
    { label: "Fecha Inicio", value: fd(race.startDate, "") },
    // { label: "Fecha limite", value: fd(race.dueDate, "Sin fecha fin") },
    { label: "Fecha Asignacion", value: fd(race.assignedDate, "No asignada") },
    { label: "Fecha Retiro", value: fd(race.pickDate, "No retirada") },
    { label: "Fecha Entrega", value: fd(race.endDate, "No finalizada") }
  );

  return (
    <div>
      <TwoColumnsGrid data={colunms} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/race/RaceDataComponent.tsx